// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSCommunicationType;
(function (TCSCommunicationType) {
    TCSCommunicationType[TCSCommunicationType["None"] = 0] = "None";
    TCSCommunicationType[TCSCommunicationType["Letter"] = 1] = "Letter";
    TCSCommunicationType[TCSCommunicationType["Email"] = 2] = "Email";
    TCSCommunicationType[TCSCommunicationType["SMS"] = 4] = "SMS";
    TCSCommunicationType[TCSCommunicationType["Phone"] = 8] = "Phone";
    TCSCommunicationType[TCSCommunicationType["Fax"] = 16] = "Fax";
})(TCSCommunicationType || (TCSCommunicationType = {}));
//# sourceMappingURL=tCSCommunicationType.js.map